module.exports = __webpack_public_path__ + "static/media/icon-session-2.2a6b864e.svg";